import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterItemToResolve',
})
export class FilterItemToResolve implements PipeTransform {
  transform(items: any[], searchText = ''): any {
    let field = 'form_name';
    if (!items || !searchText || !field) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter((item) => item[field] && item[field].toString().toLowerCase().includes(searchText));
  }
}
